import {
  CREATE_WATCHLIST_IGNORING_PROPERTY,
} from '../types';

import createAsyncActions from '../../../utilities/createAsyncActions';

export const {
  createWatchListIgnoringProperty,
  createWatchListIgnoringPropertyPending,
  createWatchListIgnoringPropertyFulfilled,
  createWatchListIgnoringPropertyRejected,
} = createAsyncActions(CREATE_WATCHLIST_IGNORING_PROPERTY, 'createWatchListIgnoringProperty');


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/actions/createWatchListIgnoringPropertyActions.js